import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromState from './ranklist.state';

const { selectIds, selectEntities, selectAll, selectTotal } =
  fromState.adapter.getSelectors();

export const selectRanklistState =
  createFeatureSelector<fromState.RanklistState>(fromState.ranklistEntityKey);

export const selectRanklistIds = createSelector(selectRanklistState, selectIds);

export const selectRanklistEntities = createSelector(
  selectRanklistState,
  selectEntities,
);

export const selectAllRanklistItemsPresent = createSelector(
  selectRanklistState,
  selectAll,
);

export const selectRanklistItemsPresentCount = createSelector(
  selectRanklistState,
  selectTotal,
);

export const selectChampionsByFilter = (
  month: string,
  roomId: string,
  level: string,
) =>
  createSelector(
    selectAllRanklistItemsPresent,
    (entries: fromState.RanklistEntity[]) =>
      entries.filter(
        (entry) =>
          entry.room === roomId &&
          entry.level === level &&
          entry.month === month,
      ),
  );
